export default __webpack_public_path__ + "static/media/ethereum.56be968d.svg";